import { toast } from 'sonner'
import { useState } from 'react'

import { StorePersistKeys } from 'src/types'
import { useLocales } from 'src/contexts'

import { useManageFuelHistory } from 'src/hooks/useManageFuelHistory'

import { FuelType } from 'src/pages/FuelTracking/enums'
import { getDictionaryFuelType } from 'src/features/FuelHistoryCard/helpers'
import { queryClient } from 'src/features/AppProviders/constants'

export const useFuelHistoryCard = (fuelType: FuelType) => {
  const { locale, translations } = useLocales()

  const { deleteFuelHistory } = useManageFuelHistory()

  const [isEditMode, setIsEditMode] = useState<boolean>(false)

  const handleDelete = (itemId: string): void => {
    deleteFuelHistory(itemId, {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [StorePersistKeys.FUEL_HISTORY],
        })
        toast(translations.trackFuel.historyFuel.toast.success.title, {
          description:
            translations.trackFuel.historyFuel.toast.success.description,
          action: {
            label:
              translations.trackFuel.historyFuel.toast.success.action.label,
            onClick: () => toast.dismiss(),
          },
        })
      },
      onError: err => {
        toast(translations.trackFuel.historyFuel.toast.error.title, {
          description:
            translations.trackFuel.historyFuel.toast.error.description + err,
          action: {
            label: translations.trackFuel.historyFuel.toast.error.action.label,
            onClick: () => toast.dismiss(),
          },
        })
      },
    })
  }

  const toggleEditMode = (): void => {
    setIsEditMode(prevState => !prevState)
  }

  return {
    language: locale,
    localeFields: translations.trackFuel.addInfoFuel,
    locale: translations.trackFuel.historyFuel,
    metricQuantity:
      fuelType === FuelType.Electricity
        ? translations.trackFuel.historyFuel.kWh
        : translations.trackFuel.historyFuel.liters,
    handleDelete,
    isEditMode,
    toggleEditMode,
    fuelDictionary: getDictionaryFuelType(translations.trackFuel.addInfoFuel),
  }
}
